export var Protocol;
(function (Protocol) {
    Protocol["AMMV1"] = "AMMV1";
    Protocol["AMMV2"] = "AMMV2";
    Protocol["PMMV5"] = "PMMV5";
    Protocol["RFQV1"] = "RFQV1";
    Protocol["RFQV2"] = "RFQV2";
})(Protocol || (Protocol = {}));
//# sourceMappingURL=protocol.js.map